import { Component } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'demo-media',
    templateUrl: './demo-media.html',
    styleUrls: ['./demo-common.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DemoMediaComponent {
    thumbShape: 'default' | 'round' = 'default';
    thumbColor = 'primary';
    imageReadonly = true;

    colors = ['primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'medium', 'dark'];

    thumbs = [
        { title: 'Alice', color: 'primary', icon: 'person-outline' },
        { title: 'Bob', color: 'success', icon: 'star-outline' },
        { title: 'Carol', color: 'warning', icon: 'heart-outline' },
        { title: 'Dave', color: 'danger', icon: 'flame-outline' },
    ];

    constructor(private change: ChangeDetectorRef) {
    }

    toggleShape() {
        this.thumbShape = this.thumbShape === 'default' ? 'round' : 'default';
        this.change.markForCheck();
    }

    toggleImageReadonly() {
        this.imageReadonly = !this.imageReadonly;
        this.change.markForCheck();
    }

    onThumbSelect(title: string) {
        console.log('Thumb selected:', title);
    }
}
